var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"page-wrapper"},[_c('Navbar'),_vm._t("default"),_c('Footer')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }